// @ts-strict-ignore
import { Heading } from '../ui/Heading'
import Indicators from './Indicators'
import SliderNavButton from './SliderNavButton'
import { Container, Track, breakpoints, useSlider } from '@gassan-ui'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import _chunk from 'lodash.chunk'
import { rem } from 'polished'
import { Fragment, useMemo, useRef } from 'react'
import { useArticlesQuery } from '@generated'
import { RCPOProductCard } from '@components/_rcpo/ProductCard'
import { RCPOProductCardLoading } from '@components/_rcpo/ProductCardLoading'
import { useTranslation } from 'next-i18next'

type Props = {
  currentProductId: string
}

const MayAlsoLike = ({ currentProductId }: Props) => {
  const { t } = useTranslation('rolex')
  const [{ data: allArticles }] = useArticlesQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
      },
      pagination: {
        limit: 7, // Limit 7 because we an extra item in case the current product is in the list
      },
    },
  })

  const isTabletUp = useBreakpoint(breakpoints.small)
  const trackRef = useRef<HTMLDivElement>(null)
  const chunks = useMemo(() => {
    if (allArticles?.articles?.items) {
      const filteredItems = allArticles.articles.items
        .filter((item) => item?.id !== currentProductId)
        .slice(0, 6)

      return _chunk(filteredItems, isTabletUp ? 3 : 2)
    }
    return _chunk(Array(6).fill(null), isTabletUp ? 3 : 2)
  }, [allArticles, isTabletUp, currentProductId])

  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index, goToIndex } = useSlider({
    trackRef,
    forceUpdate: chunks.length,
  })

  return (
    <div className="overflow-hidden">
      <Container
        maxWidth={{ _: '90%', large: rem(1140) }}
        mb={{ _: '3rem', small: '6rem', large: '7.5rem' }}
      >
        <Heading variant="very-small-title" className="mb-5" as="h2">
          {t('mayAlsoLike.title')}
        </Heading>
        <div className="relative mb-8 md:mb-9 lg:mb-10">
          <Track ref={trackRef} onTouchEnd={onTouchEnd}>
            {chunks.map((chunk, key) => (
              <Fragment key={key}>
                <div className="mr-4 grid min-w-full snap-start grid-cols-2 gap-x-4 sm:grid-cols-3">
                  {chunk.map((item, key) => (
                    <div className="group w-full" key={key}>
                      {allArticles ? <RCPOProductCard data={item} /> : <RCPOProductCardLoading />}
                    </div>
                  ))}
                </div>
              </Fragment>
            ))}
          </Track>
          {chunks.length > 1 && (
            <div className="pointer-events-none absolute -left-6 top-1/2 z-[2] flex w-[calc(100%+50px)] -translate-y-1/2 justify-between">
              <SliderNavButton direction="prev" onClick={prev} disabled={!canMoveLeft} />
              <SliderNavButton direction="next" onClick={next} disabled={!canMoveRight} />
            </div>
          )}
        </div>
        <Indicators
          activeIndex={index}
          onClick={(index) => {
            goToIndex(index)
          }}
          count={chunks.length}
        />
      </Container>
    </div>
  )
}

export default MayAlsoLike
